import {expirationRuleDefaults} from './defaults';
import {ExpirationRule} from './types';

export const createExpirationRule = (): ExpirationRule => ({
	...expirationRuleDefaults,
});

export default createExpirationRule;
